export enum TicketStatus {
  declined = 'rejected',
  pending = 'pending',
  accepted = 'confirmed',
  callback = 'callback'
}
